module.exports = __webpack_public_path__ + "babdd4c87154fa98cb4726df94d05e45.svg";